export default [
    {
        value: 'mr',
        label: window.i18n.__('M')
    },
    {
        value: 'mrs',
        label: window.i18n.__('Mme')
    },
    {
        value: 'ms',
        label: window.i18n.__('Mlle')
    },
]